import { ArrangeProps, arrange } from './arrange';

/**
 * Component for stacking items vertically
 *
 * Responsibilities:
 *
 * 1. Stack items on top of each other
 * 2. Spacing between items
 * 3. Alignment of items
 */
export const gridStack = (props: Omit<ArrangeProps<'gridStack'>, 'layout'>) => {
	return arrange({ ...props, layout: 'gridStack' });
};
